import { cn } from "@design-system/utils";
import * as React from "react";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "bg-shape-neutral-filled-background animate-pulse rounded-md",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
